import { render } from "./DashboardRiskBadge.vue?vue&type=template&id=171d4668"
import script from "./DashboardRiskBadge.vue?vue&type=script&lang=js"
export * from "./DashboardRiskBadge.vue?vue&type=script&lang=js"
script.render = render

export default script